<template>
  <div class="mb-10 xrelative inserate">

    <logo-header v-if="false" :base_url_assets="base_url_assets" />

    <select-campain
      :campains="campains"
      :selected_campain="campain_data.banner_type"
      @select="change_campain"
      :base_url_assets="base_url_assets"
    />

    <div
      v-if="campain_data.banner_type > 0"
      class="mt-10"
    >
      <h2>Beschreiben Sie die Veranstaltung</h2>
      <p class="mt-1">
        Je nach ausgewählter Anzeige haben Sie eine vorgegebene Zeichenanzahl zur Verfügung.
      </p>

      <div>
        <div class="mt-1 relative">
          <textarea v-model="campain_data.title" placeholder="Titel der Veranstaltung" />
          <span
            class="px-2 py-1 text-white rounded-lg absolute bottom-0 right-0"
            :class="{
              'bg-green-500': title_letter_left >= 0,
              'bg-red-500': title_letter_left < 0,
            }">{{ title_letter_left }}</span>
        </div>
        <div class="mt-1 relative">
          <textarea v-model="campain_data.referent" placeholder="Referent/Referentin (Name und kurze Beschreibung)" />
          <span
            class="px-2 py-1 text-white rounded-lg absolute bottom-0 right-0"
            :class="{
              'bg-green-500': referent_letter_left >= 0,
              'bg-red-500': referent_letter_left < 0,
            }">{{ referent_letter_left }}</span>
        </div>
        <div class="mt-1">
          <input type="text" v-model="campain_data.event_date" placeholder="Datum der Veranstaltung">
        </div>
        <div class="mt-1">
          <input type="text" v-model="campain_data.contact_info" placeholder="Kontakt zur Anmeldung (Tel und/oder Mail)">
        </div>
        <div class="mt-1">
          <input type="text" v-model="campain_data.homepage" placeholder="Homepage">
        </div>
      </div>

      <div class="mt-1 relative" v-if="current_campain.text.enabled == true">
        <label>Beschreiben Sie die Veranstaltung</label>
        <textarea
          v-model="campain_data.comment"
          cols="30"
          rows="12"
          class="text-xl"
          placeholder="Beschreibung der Veranstaltung (Inhalt, Preis, Ort, Anmeldung, ...)"></textarea>
        <div class="text-right text-2xl font-semibold">
          <span
            class="px-2 py-1 text-white rounded-lg absolute bottom-0 right-0"
            :class="{
              'bg-green-500': campain_left >= 0,
              'bg-red-500': campain_left < 0,
            }"
          >
            {{ campain_left }}
          </span>
        </div>
      </div>
    </div>

    <div
      v-if="campain_data.banner_type > 0 && current_campain.image.enabled == true"
      class="mt-10"
      :class="{
        'opacity-25': campain_data.banner_type <= 0
      }"
    >
      <h2>Laden Sie Ihr Seminarfoto hoch</h2>
      <p class="mt-1">
        Laden Sie nun ein passendes Bild im Verhältnis 5x4 cm hoch. Die minimale Bildgröße
        für eine Anzeige in unserem Magazin liegt bei 2500x2000px und einer Auflösung
        von 300 dpi. Bitte laden Sie das Bild als .jpg- oder .png-Datei hoch.
      </p>

      <file-upload
        input-id="seminar-box"
        id="seminar"
        ref="upload"
        v-model="files"
        :drop="`#seminar`"
        :maximum="1"
        :drop-directory="false"
        @input-filter="input_filter"
        @input-file="input_file"
        class="w-full"
      >
        <div
          class="mt-1 border-dashed border-2 flex justify-center justify-items-center text-center align-middle items-center min-h-64 p-8"
          :class="{
            'bg-green-300': $refs.upload && $refs.upload.dropActive,
            'bg-green-400': image_correct > 0,
            'bg-red-500': image_correct < 0,
          }"
        >
          <button v-if="blob || files.length > 0"
                  @click.prevent="delete_file(preview_file, 'seminar')"
                  class="z-10 absolute right-0 top-0 rounded bg-red-600 text-white px-2 py-1">
            Bild löschen
          </button>
          <div v-if="files.length == 0">
            Ziehen Sie ein Bild in diesen Bereich.
          </div>
          <div v-else>
            <img v-if="preview_file" ref="edit_image" :src="preview_file.url" class="mb-2">
          </div>
        </div>
      </file-upload>

      <pre v-if="debug">
        {{ preview_file }}
      </pre>

      <ul>
        <li v-for="(err,idx) in image_errors" :key="idx" class="text-red-600">
          {{ err }}
        </li>
      </ul>

      <div v-if="progress >= 0" class="w-full mt-2">
        <div id="upload-progress-bar" class="h-3 rounded bg-green-400 w-0"
              :style="{ width: progress + '%' }"></div>
      </div>
    </div>

    <div
      v-if="current_campain.referent && current_campain.referent.enabled == true"
      class="mt-10"
    >
      <h2>Laden Sie hier Ihr Portraitfoto hoch</h2>
      <p class="mt-1">
        Für die Veröffentlichung auf Magazin und Website bitten wir Sie
        um ein aktuelles referentbild von Ihnen.
        Die minimale Bildgröße liegt bei mind. 2.500 px Breite und
        einer Auflösung 300 dpi. Bitte laden Sie das Bild als als
        .jpg oder .png-Datei hoch
      </p>

      <file-upload
        input-id="referent-box"
        id="referent"
        ref="uploadReferent"
        v-model="referents"
        :drop="`#referent`"
        :maximum="1"
        :drop-directory="false"
        @input-filter="input_referent_filter"
        @input-file="input_referent_file"
        class="w-full"
      >
        <div
          class="mt-1 border-dashed border-2 flex justify-center justify-items-center text-center align-middle items-center min-h-64 p-8"
          :class="{
            'bg-green-300': $refs.uploadReferent && $refs.uploadReferent.dropActive,
            'bg-green-400': referent_image_correct > 0,
            'bg-red-500': referent_image_correct < 0,
          }"
        >
          <button v-if="blob || referents.length > 0"
                  @click.prevent="delete_file(referent_preview_file, 'referent')"
                  class="z-10 absolute right-0 top-0 rounded bg-red-600 text-white px-2 py-1">
            Bild löschen
          </button>
          <div v-if="referents.length == 0">
            Ziehen Sie ein Bild in diesen Bereich.
          </div>
          <div v-else>
            <img v-if="referent_preview_file" ref="referent_edit_image" :src="referent_preview_file.url" class="mb-2">
          </div>
        </div>
      </file-upload>

      <pre v-if="debug">
        --{{ referents }}--
        --{{ referent_preview_file }}--
      </pre>

      <ul>
        <li v-for="(err,idx) in referent_image_errors" :key="idx" class="text-red-600">
          {{ err }}
        </li>
      </ul>

      <div v-if="progress_referent >= 0" class="w-full mt-2">
        <div id="upload-referent-progress-bar" class="h-3 rounded bg-green-400 w-0"
              :style="{ width: progress_referent + '%' }"></div>
      </div>
    </div>

    <div v-if="campain_data.banner_type > 0">
      <div class="mt-2">
        <textarea rows="3" v-model="campain_data.additional_comment" placeholder="Ihre Anmerkungen (Weitere Referent*innen-Bilder und Beschreibung an information@arbogast.at senden)" />
      </div>
    </div>

    <div v-if="debug">
      -- {{ image_errors }} --
      *** {{ current_campain }} ***
    </div>

    <user-data
      v-if="campain_data.banner_type > 0"
      :campain_data="campain_data" />

    <div v-if="campain_data.banner_type > 0" class="mt-2">
      <label for="campain_data_agb">
        <input type="checkbox" v-model="campain_data.agb" id="campain_data_agb"> Sie haben unsere
          <a href="https://arbogast.at/buchen/allgemeine-geschaeftsbedingungen/" target="_blank">AGB</a> gelesen und akzeptieren diese.
      </label>
      <label for="campain_data_dsvgo">
        <input type="checkbox" v-model="campain_data.dsvgo" id="campain_data_dsvgo"> Sie haben unsere <a href="https://arbogast.at/datenschutzerklaerung/" target="_blank">Datenschutzerklärung</a> gelesen und akzeptieren diese.
      </label>
    </div>

    <div v-if="campain_data.banner_type" class="mt-5 flex gap-2 justify-content-between items-center">
      <button
        v-if="readonly"
        @click="new_data"
        class="border py-4 px-6 text-white text-md bg-red-500 cursor-pointer disabled:bg-gray-400 disabled:cursor-not-allowed">
        Ein weiters Inserat aufgeben?
      </button>

      <button
        v-if="!readonly"
        @click="send_data_to_server"
        :disabled="!all_infos_given || campain_data.data_verified <= 0 || transfer_in_progress"
        class="border py-4 px-6 text-white text-md bg-red-900 cursor-pointer disabled:bg-gray-400 disabled:cursor-not-allowed">
        Anzeige verbindlich buchen
      </button>

      <div class="text-right">
        <label for="campain_data_data_verified">
          <input type="checkbox" v-model="campain_data.data_verified" id="campain_data_data_verified">
          Ich bestätige, dass ich die Daten sorgfältig eingegeben und überprüft habe.
        </label>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import FileUpload from "vue-upload-component/src/FileUpload.vue"
import { DirectUpload } from '@rails/activestorage'

import LogoHeader from './components/header.vue'
import UserData from './components/user-data.vue'
import SelectCampain from './components/select-campain.vue'
import Ok from './components/ok.vue'
import NOk from './components/nok.vue'

export default {
  data() {
    return {
      debug: false,

      session_id: null,
      csrf: null,

      readonly: false,

      advertisment_id: null,
      image_uploaded: 0,

      max_referent_length: 70,
      max_title_length: 60,

      files: [],
      referents: [],

      referent_preview_file: null,
      preview_file: null,

      image_status: -1,
      referent_image_status: -1,

      blob: null,
      progress: -1,
      progress_referent: -1,
      started: false,

      user_id: null,
      user_fullname: null,
      transfer_in_progress: false,

      referent_image_errors: [],
      image_errors: [],

      campain_data: {
        gender: '',
        email: '',
        telefon: '',
        company: '',
        lastname: '',
        firstname: '',
        street: '',
        zipcode: '',
        city: '',
        country_id: '',
        dsvgo: 0,
        agb: 0,
        data_verified: 0,

        banner_type: 0,
        title: '',
        referent: '',
        event_date: '',
        contact_info: '',
        hompage: '',
        comment: '',
        additional_comment: ''
      },

      image_errors: [],
      referent_image_errors: [],

      campains: [
        {
          id: 1,
          title: 'Klein',
          subtitle: 'Kleine Textbox',
          preview: 'small.png',
          description: 'Box mit Text zur Beschreibung Ihrer Veranstaltung',
          points: [
            { text: 'Box mit Text zur Bewerbung Ihrer Veranstaltung' },
            { text: 'Veranstaltungstitel, Termin, kurze Beschreibung der Referent*in, Anmelde-Kontakt und Website-Link (falls vorhanden)' },
            { text: 'Kurze Veranstaltungsbeschreibung mit max. 100 Zeichen (inkl. Leerzeichen)' },
            { text: 'Veröffentlichung einmalig im Arbogast-Magazin und auf www.arbogast.at' },
            { text: '<strong>Preis 100 Euro</strong>' }
          ],
          image: {
            enabled: false
          },
          referent: {
            enabled: true,
            min_width: 2500,
            ration: 4/5
          },
          text: {
            enabled: true,
            max_length: 100,
          },
          price: 100
        },
        { id: 2,
          title: 'Klein',
          subtitle: 'Kleine Bildbox',
          preview: 'small.png',
          description: "Box mit Bild zur Darstellung Ihrer Veranstaltung",
          points: [
            { text: 'Box mit Bild zur Bewerbung Ihrer Veranstaltung' },
            { text: 'Bild: Breite mind. 2500px, Bildauflösung 300dpi, als .jpg- oder .png-Datei' },
            { text: 'Veranstaltungstitel, Termin, Referent*in, Anmelde-Kontakt und Website-Link (falls vorhanden)' },
            { text: 'Veröffentlichung einmalig im Arbogast-Magazin und auf www.arbogast.at' },
            { text: '<strong>Preis 100 Euro</strong>' }
          ],
          text: {
            enabled: false
          },
          image: {
            enabled: true,
            min_width: 2500,
            ration: 4/5
          },
          referent: {
            enabled: true,
            min_width: 2500,
            ration: 4/5
          },
          price: 100
        },
        {
          id: 3,
          title: 'Mittel',
          subtitle: 'Mittlere Text- und Bildbox',
          preview: 'medium.png',
          description: 'Box mit Bild + Text zur Darstellung Ihrer Veranstaltung',
          points: [
            { text: 'Box mit Text und Bild zur Bewerbung Ihrer Veranstaltung' },
            { text: 'Veranstaltungstitel, Termin, kurze Beschreibung der Referent*in, Anmelde-Kontakt und Website-Link (falls vorhanden)' },
            { text: 'Kurze Veranstaltungsbeschreibung mit max. 300 Zeichen (inkl. Leerzeichen)' },
            { text: 'Bild: Breite mind. 2500px, Bildauflösung 300dpi, als .jpg- oder .png-Datei' },
            { text: 'Veröffentlichung einmalig im Arbogast-Magazin und auf www.arbogast.at' },
            { text: '<strong>Preis 200 Euro</strong>' },
          ],
          image: {
            enabled: true,
            min_width: 2500,
            ration: 4/5
          },
          referent: {
            enabled: true,
            min_width: 2500,
            ration: 4/5
          },
          text: {
            enabled: true,
            max_length: 300,
          },
          price: 200
        },
        {
          id: 4,
          title: 'Groß',
          subtitle: 'Große Text- und Bildbox',
          preview: 'large.png',
          description: 'Spalte mit Bild und Text zur Hervorhebung Ihrer Veranstaltung',
          points: [
            { text: 'Box mit Text und Bild zur Bewerbung Ihrer Veranstaltung' },
            { text: 'Veranstaltungstitel, Termin, kurze Beschreibung der Referent*in, Anmelde-Kontakt und Website-Link (falls vorhanden)' },
            { text: 'Veranstaltungsbeschreibung mit max. 800 Zeichen (inkl. Leerzeichen)' },
            { text: 'Bild: Breite mind. 2500px, Bildauflösung 300dpi, als .jpg- oder .png-Datei' },
            { text: 'Veröffentlichung einmalig im Arbogast-Magazin und auf www.arbogast.at' },
            { text: '<strong>Preis 300 Euro</strong>' },
          ],
          image: {
            enabled: true,
            min_width: 2500,
            ration: 4/5
          },
          referent: {
            enabled: true,
            min_width: 2500,
            ration: 4/5
          },
          text: {
            enabled: true,
            max_length: 800,
          },
          price: 300
        },
        {
          id: 5,
          title: 'Sonderform',
          subtitle: 'Sonderform nur Online',
          preview: 'web.png',
          description: 'Spalte mit Bild und Text zur Hervorhebung Ihrer Veranstaltung',
          points: [
            { text: 'Box mit Text und Bild zur Bewerbung Ihrer Veranstaltung' },
            { text: 'Veranstaltungstitel, Termin, kurze Beschreibung der Referent*in, Anmelde-Kontakt und Website-Link (falls vorhanden)' },
            { text: 'Veranstaltungsbeschreibung mit max. 800 Zeichen (inkl. Leerzeichen)' },
            { text: 'Bild: Breite mind. 2500px, Bildauflösung 300dpi, als .jpg- oder .png-Datei' },
            { text: 'Veröffentlichung auf www.arbogast.at ' },
            { text: '<strong>Preis 150 Euro</strong>' },
          ],
          image: {
            enabled: true,
            min_width: 2000,
            ration: 5/4
          },
          referent: {
            enabled: true,
            min_width: 2500,
            ration: 4/5
          },
          text: {
            enabled: true,
            max_length: 800,
          },
          price: 150
        }
      ]
    }
  },
  computed: {
    base_url_assets() {
      if (process.env.NODE_ENV.trim() == 'development') {
        // return '/programm'
        return 'https://booking.arbogast.at/programm'
        // return 'http://localhost:3000'
      } else {
        return '/programm'
      }
    },
    base_url() {
      if (process.env.NODE_ENV.trim() == 'development') {
        // return 'https://booking.arbogast.at/programm'
        return 'http://localhost:3000/programm'
      } else {
        return 'https://booking.arbogast.at/programm'
        // return '/programm'
      }
    },
    base_upload_url() {
      if (process.env.NODE_ENV.trim() == 'development') {
        // return 'https://booking.arbogast.at'
        return 'http://localhost:3000'
      } else {
        // return '/programm'
        return 'https://booking.arbogast.at'
      }
    },
    title_letter_left() {
      return this.max_title_length - this.campain_data.title.length
    },
    referent_letter_left() {
      return this.max_referent_length - this.campain_data.referent.length
    },
    campain_left() {
      let max_length = this.current_campain?.text?.max_length || 0
      return max_length - this.campain_data.comment.length
    },
    campain_text_length_valid() {
      return this.campain_left >= 0
    },
    current_campain() {
      if (this.campain_data.banner_type <= 0) return false
      return this.campains.find(e => e.id == this.campain_data.banner_type)
    },
    image_correct() {
      return this.image_status
    },
    referent_image_correct() {
      return this.referent_image_status
    },
    all_infos_given() {
      if (!this.campain_data.email ) { console.log('email'); return false }
      if (! this.valid_email(this.campain_data.email) ) { console.log('email format'); return false }

      if (!this.campain_data.telefon ) { console.log('telefon'); return false }
      if (!this.valid_telefon(this.campain_data.telefon) ) { console.log('telefon number'); return false }

      // if (!this.campain_data.company ) { console.log('company'); return false }
      if (!this.campain_data.gender ) { console.log('gender'); return false }
      if (!this.campain_data.lastname ) { console.log('lastname'); return false }
      if (!this.campain_data.firstname ) { console.log('firstname'); return false }
      if (!this.campain_data.street ) { console.log('street'); return false }

      if (!this.campain_data.zipcode ) { console.log('zipcode'); return false }
      if (! this.valid_number(this.campain_data.zipcode) ) { console.log('zipcode number'); return false }

      if (!this.campain_data.city ) { console.log('city'); return false }
      if (!this.campain_data.country_id) { console.log('country_id'); return false }
      if (!this.campain_data.title ) { console.log('titel'); return false }
      if (!this.campain_data.referent ) { console.log('referent'); return false }
      if (!this.campain_data.event_date ) { console.log('event_date'); return false }
      if (!this.campain_data.contact_info ) { console.log('contact_info'); return false }
      // if (!this.campain_data.homepage ) { console.log('homepage'); return false }
      if (!this.campain_data.banner_type ) { console.log('banner_type'); return false }

      if (!this.campain_data.data_verified ) { console.log('data_verified'); return false }
      if (!this.campain_data.dsvgo ) { console.log('dsvgo'); return false }
      if (!this.campain_data.agb ) { console.log('agb'); return false }

      if (this.title_letter_left < 0) { console.log('title to long'); return false }
      if (this.referent_letter_left < 0) { console.log('referent to long'); return false }

      if ( this.current_campain.text.enabled &&
           !this.campain_text_length_valid &&
           this.campain_data.comment.length < 10 ) { console.log('text'); return false }
      if ( this.current_campain.image.enabled && !this.preview_file ) { console.log('preview_file'); return false }

      console.log('all infos given')
      return true
    }
  },
  methods: {
    valid_email(email) {
      if (email?.length <= 0) return true
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true
      } else {
        return false
      }
    },
    valid_number( field ) {
      if (field?.length <= 0) return true
      return /^[0-9]+$/.test(field)
    },
    valid_telefon( field ) {
      if (field?.length <= 0) return true
      return /^[0-9+ ]+$/.test(field)
    },
    change_campain(banner_type) {
      this.campain_data.banner_type = banner_type
      this.check_image('seminar')
      this.check_image('referent')
    },
    send_data_to_server() {
      console.log('start transfer advertisment')
      this.transfer_in_progress = true

      const data = {
        email: this.campain_data.email,
        telefon: this.campain_data.telefon,
        company: this.campain_data.company,
        gender: this.campain_data.gender,
        lastname: this.campain_data.lastname,
        firstname: this.campain_data.firstname,
        street: this.campain_data.street,
        zipcode: this.campain_data.zipcode,
        city: this.campain_data.city,
        country_id: this.campain_data.country_id,

        banner_type: this.campain_data.banner_type,
        title: this.campain_data.title,
        referent: this.campain_data.referent,
        event_date: this.campain_data.event_date,
        contact_info: this.campain_data.contact_info,
        homepage: this.campain_data.homepage,
        comment: this.campain_data.comment,
        additional_comment: this.campain_data.additional_comment,

        dsvgo: this.campain_data.dsvgo,
        agb: this.campain_data.agb,
        data_verified: this.campain_data.data_verified,

        image: this.preview_file?.signed_id,
        referent_image: this.referent_preview_file?.signed_id
      }
      let result = axios.post(`${this.base_url}/api/v2/advertisments`,
                             { advertisment: data },
                             {
                               // withCredentials: true,
                               headers: {
                                 "Content-Type": "application/json",
                                 // "Access-Control-Allow-Credentials": "true",
                                 // "Credentials": "same-origin",
                                 "Accept": "application/json",
                                 "X-CSRF-Token": this.csrf
                               }
                             }
                             )
      .then((response) => {
        this.transfer_in_progress = false

        if( this.debug ) console.log('response from server', response)
        if (response.data.status == 'ok') {
          this.readonly = true
          alert('Wir danken für Ihre Zusendung und bearbeiten diese umgehend.')
        }
      }).catch((error) => {
        this.transfer_in_progress = false

        if( this.debug ) console.log('error from server', error)
      })
    },

    check_image() {
      if (!this.preview_file) return this.image_status = -1

      this.image_errors = []
      let result = 1

      if (this.preview_file?.width < this.current_campain.image.min_width) {
        result = -1;
        this.image_errors.push(`Das Bild muss mindestens ${this.current_campain.image.min_width}px breit sein, ist aber nur ${this.preview_file.width}px breit.`)
      }

      if( this.debug ) console.log('check_image error:', result)
      this.image_status = result
    },

    check_referent_image() {
      if (!this.referent_preview_file) return this.referent_image_status = -1

      this.referent_image_errors = []
      let result = 1

      if (this.referent_preview_file?.width < this.current_campain.referent.min_width) {
        result = -1;
        this.referent_image_errors.push(`Das Bild muss mindestens ${this.current_campain.referent.min_width}px breit sein, ist aber nur ${this.referent_preview_file.width}px breit.`)
      }

      if( this.debug ) console.log('check_referent_image error:', result)
      this.referent_image_status = result
    },

    new_data() {
      this.readonly = false
      this.advertisment_id = null
      this.image_uploaded = 0

      this.files = []
      this.referent_preview_file = null
      this.preview_file = null
      this.image_status = -1

      this.referents = []
      this.referent_preview_file = null
      this.referent_image_status = -1

      this.blob = null

      this.progress = 0
      this.progress_referent = 0

      this.started = false

      this.campain_data.title = ''
      this.campain_data.banner_type = 0
      this.campain_data.referent = ''
      this.campain_data.event_date = ''
      this.campain_data.contact_info = ''
      this.campain_data.homepage = ''
      this.campain_data.comment = ''
    },

    delete_file(file, type) {
      console.log(file)
      let result = axios.get(
        `${this.base_url}/api/v2/advertisments/remove/${file.id}`,
        {
          // withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            // "Credentials": "same-origin",
            "Accept": "application/json",
            "X-CSRF-Token": this.csrf
          }
        })
        .then((response) => {
          console.log('delete_image successful', response.data)
          // return response
          if (response.data?.status) {
          }
        })
        .catch((error) => {
          console.log('upload error', error)
        })
      if (type == 'referent') {
        this.referents = []
        this.referent_image_status = -1
        this.referent_preview_file = null
        this.referent_progress = 0
      } else {
        this.files = []
        this.image_status = -1
        this.preview_file = null
        this.progress = 0
      }
      this.started = false
    },

    directUploadWillStoreFileWithXHR(request) {
      request.upload.addEventListener("progress", event => this.directUploadDidProgress(event))
    },

    directUploadDidProgress(event) {
      if (this.progress = 0) {
        this.progress = Math.floor(event.loaded / event.total * 100)
      } else {
        this.progress_referent = Math.floor(event.loaded / event.total * 100)
      }
    },

    input_filter(new_file, old_file, prevent) {
      let that = this

      // console.log('input_filter', new_file, old_file)
      if (!/\.(pdf|jpeg|jpe|jpg|gif|png|webp)$/i.test(new_file.name)) {
        return prevent()
      }
      this.preview_file = { ...new_file }
      if( this.debug ) console.log('input_filter: ', new_file)
      if (new_file && (!old_file || new_file.file !== old_file.file)) {
        this.preview_file.url = ''
        let URL = window.URL || window.webkitURL
        let img = new Image()

        img.onload = function() {
          if( this.debug ) console.log('picture size - h:', this.height, 'w:', this.width)
          that.preview_file.width = this.width
          that.preview_file.height = this.height
          return false
        }

        if (URL && URL.createObjectURL) {
          this.preview_file.url = URL.createObjectURL(this.preview_file.file)
          img.src = this.preview_file.url
          // console.log('width', this.preview_file.width)
        }
      }
    },

    input_file(new_file, old_file) {
      let upload = null
      const url = `${this.base_upload_url}/rails/active_storage/direct_uploads`
      this.progress = 0

      console.log('input_file:', new_file, 'old', old_file, url)
      if (!new_file) return

      try {
        upload = new DirectUpload(new_file.file, url, this)
      } catch(e) {
        console.log('got an error while instantiating directupload', e)
      }

      upload.create((error, blob) => {
        if (error) {
          if( this.debug ) console.log('input_file: got an error during upload:', error)
        } else {
          if( this.debug ) console.log('input_file: successfully blob: ', blob)
          this.progress = -1
          this.blob = blob
          this.preview_file.key = blob.key
          this.preview_file.signed_id = blob.signed_id
          this.preview_file.filename = blob.filename
          this.preview_file.filepath = blob.filepath
          this.preview_file.filepath = blob.filepath
          this.preview_file.id = blob.id
          this.advertisment_id = this.preview_file.advertisment_id = blob.advertisment_id

          this.check_image()
        }
      })
      if( this.debug ) console.log('input_file end')
    },

    input_referent_filter(new_file, old_file, prevent) {
      let that = this

      // console.log('input_referent_filter', new_file, old_file)
      if (!/\.(pdf|jpeg|jpe|jpg|gif|png|webp)$/i.test(new_file.name)) {
        return prevent()
      }
      this.referent_preview_file = { ...new_file }
      if( this.debug ) console.log('input_referent_filter: ', new_file)
      if (new_file && (!old_file || new_file.file !== old_file.file)) {
        this.referent_preview_file.url = ''
        let URL = window.URL || window.webkitURL
        let img = new Image()

        img.onload = function() {
          if( this.debug ) console.log('picture size - h:', this.height, 'w:', this.width)
          that.referent_preview_file.width = this.width
          that.referent_preview_file.height = this.height
          return false
        }

        if (URL && URL.createObjectURL) {
          this.referent_preview_file.url = URL.createObjectURL(this.referent_preview_file.file)
          img.src = this.referent_preview_file.url
          // console.log('width', this.referent_preview_file.width)
        }
      }
    },
    input_referent_file(new_file, old_file) {
      let upload = null
      const url = `${this.base_upload_url}/rails/active_storage/direct_uploads`
      this.progress_referent = 0

      console.log('input_referent_file:', new_file, 'old', old_file, url)

      if (!new_file) return

      try {
        upload = new DirectUpload(new_file.file, url, this)
      } catch(e) {
        console.log('got an error while instantiating directupload', e)
      }

      upload.create((error, blob) => {
        if (error) {
          if( this.debug ) console.log('input_referent_file: got an error during upload:', error)
        } else {
          if( this.debug ) console.log('input_referent_file: successfully blob: ', blob)
          this.progress_referent = -1
          this.blob = blob
          this.referent_preview_file.key = blob.key
          this.referent_preview_file.signed_id = blob.signed_id
          this.referent_preview_file.filename = blob.filename
          this.referent_preview_file.filepath = blob.filepath
          this.referent_preview_file.filepath = blob.filepath
          this.referent_preview_file.id = blob.id
          this.advertisment_id = this.referent_preview_file.advertisment_id = blob.advertisment_id

          this.check_referent_image()
        }
      })
      if( this.debug ) console.log('input_file end')
    },
    getImageUrl(name) {
      // return new URL(`./assets/images/${name}`, import.meta.url).href
    }
  },
  async mounted() {
    this.csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content");
    // this.session_id = document.getElementById("inserate")?.getAttribute("data-id")

    // await this.request_is_logged_in()

    console.log('inserat mounted: ', document.location.hash)
    this.debug = document.location.hash.includes('debug')
  },
  components: {
    LogoHeader,
    UserData,
    SelectCampain,
    FileUpload,
    Ok,
    NOk
  }
}
</script>

<style lang="scss" scoped>
.mt-1 { margin-top: 2px; }
.mt-4 { margin-top: 8px; }
.mt-10 { margin-top: 20px; }
select, option, textarea, input[type="submit"], input[type="date"], input[type="email"], input[type="text"], input[type="password"] {
  border: 1px solid #efefef;
  font-size: 13px;
  line-height: 22px;
  width: 100%;
  background-color: #efefef;
  padding: 2px 4px;
  // height: 32px !important;
  margin-bottom: 1px;
}
.inserate label {
  font-weight: 300;
}
button:disabled {
  opacity: 0.5;
}
</style>
